import { render, staticRenderFns } from "./OffscreenMenu.vue?vue&type=template&id=e437d9ac&"
import script from "./OffscreenMenu.vue?vue&type=script&lang=js&"
export * from "./OffscreenMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports